import React from 'react'
import Image from '../../../images/buyerpolicies/Termination.png'

const Termination = () => {
  return (
    <div className='sp_details_wrapper'>
      <div className='sp_details_container'>
        <div className='sp_details_image'>
            <img src={Image} alt='policy'/>
        </div>
        <div className='sp_details_details'>
            <h2>Termination</h2>
            <p>In case of breach of any rules and regulations, KAAY also possesses the legal right to terminate your account and cease your profile. If you have violated the terms of use, your order will be canceled without any information.</p>
        </div>
      </div>
    </div>
  )
}

export default Termination
